{
  "version": 1,
  "asset_id": "d86f6951-a7a0-4a4d-a7bb-67e3f2860c8d",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/d86f6951-a7a0-4a4d-a7bb-67e3f2860c8d/clip-img_2311-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/d86f6951-a7a0-4a4d-a7bb-67e3f2860c8d/clip-img_2311-poster-sm.webp",
  "original_filename": "clip-img_2311-poster-sm.webp",
  "size": 22522,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:47Z"
}
